import { isIOS } from '../../utils/platform'

/**
 * Shared constants + helpers for the app-promo surfaces (#1465):
 * AppPromoBanner (dismissable) and AppDownloadRow (permanent).
 */

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=fi.xengolf.impact_mobile'
export const APP_STORE_URL = 'https://apps.apple.com/fi/app/impact-by-xengolf/id6775428032'

// Persists the banner dismissal (AppDownloadRow is never dismissable).
export const APP_PROMO_BANNER_DISMISSED_KEY = 'impact.appPromo.banner.dismissed'

export const APP_PROMO_EVENTS = {
  bannerShown: 'app_promo.banner.shown',
  bannerClicked: 'app_promo.banner.clicked',
  bannerDismissed: 'app_promo.banner.dismissed'
} as const

// Platform-appropriate store link: iOS -> App Store, everything else -> Play.
export const storeUrlForPlatform = (): string => (isIOS() ? APP_STORE_URL : PLAY_STORE_URL)

export const isDismissed = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

export const dismiss = (key: string): void => {
  try {
    localStorage.setItem(key, '1')
  } catch {
    // private-mode / storage unavailable — dismissal won't persist, non-fatal
  }
}
